import { useTranslation } from 'component/translation';
import { Stack } from 'expo-router';
import { editorialDashModuleQuery, useModule } from 'system/structure-modules';
import { t } from 'util/stdtypes';

export default function EditorialDashboardNewStoryScreen() {
    const { AddStoryScreen } = useModule(editorialDashModuleQuery);
    const title = useTranslation(t('story_dash.add_title', 'Add story'));
    return (
        <>
            <Stack.Screen options={{ title }} />
            <AddStoryScreen />
        </>
    );
}
